import { create } from "zustand";

import type { ChecklistAnswerResponse, ChecklistLinkData } from "../types";

type ChecklistData = {
	linkData?: ChecklistLinkData;
	answerData: ChecklistAnswerResponse | null;
};

export type ChecklistContextType = {
	checklist: ChecklistData | null;
	setChecklist: (data: ChecklistData) => void;
	clearChecklist: () => void;
};

export const useChecklistStore = create<ChecklistContextType>((set) => ({
	checklist: null,
	setChecklist: (data) =>
		set({
			checklist: data,
		}),
	clearChecklist: () =>
		set({
			checklist: null,
		}),
}));
